import React, { useState, useEffect, useRef } from 'react';
import { useParams } from 'react-router-dom';
import CommentSection from './CommentSection';
import RecentPosts from './LastPosts';
import './BlogPost.css';
import { API_BASE_URL } from '../config/api';

const BlogPost = () => {
    const { slug } = useParams();
    const [post, setPost] = useState(null);
    const [loading, setLoading] = useState(true);
    const [hasLiked, setHasLiked] = useState(false);
    const [likeError, setLikeError] = useState('');
    const contentRef = useRef(null);

    useEffect(() => {
        fetchPost();
        checkIfLiked();
    }, [slug]);

    // DEBUG: Efecto para diagnosticar imágenes después del render
    useEffect(() => {
        if (post && contentRef.current) {
            //console.log('=== DEBUG BLOGPOST ===');
            //console.log('Post loaded:', post.title);
            //console.log('HTML Content length:', post.html_content.length);

            // Buscar imágenes en el HTML string
            const imgRegex = /<img[^>]+src="([^">]+)"/g;
            const matches = [...post.html_content.matchAll(imgRegex)];
            //console.log('Images found in HTML string:', matches.map(m => m[1]));

            // Verificar imágenes en el DOM después de renderizar
            setTimeout(() => {
                const images = contentRef.current.querySelectorAll('img');
                //console.log('Images in DOM:', images.length);

                images.forEach((img, index) => {
                    // console.log(`Image ${index + 1}:`, {
                    //     src: img.src,
                    //     currentSrc: img.currentSrc,
                    //      complete: img.complete,
                    //      naturalWidth: img.naturalWidth,
                    //      naturalHeight: img.naturalHeight,
                    //      alt: img.alt
                    //  });

                    // Verificar si la imagen cargó
                    if (img.complete) {
                        if (img.naturalWidth === 0) {
                            //console.log('❌ Image failed to load');
                            // Forzar recarga
                            img.src = img.src + '?t=' + Date.now();
                        } else {
                            console.log('');
                        }
                    } else {
                        console.log('');
                        // img.onload = () => console.log('✅ Image loaded after onload');
                        //img.onerror = () => console.log('❌ Image failed to load (onerror)');
                    }
                });
            }, 100);
        }
    }, [post]);

    const fetchPost = async () => {
        try {
            // console.log('Fetching post from:', `${API_BASE_URL}/api/posts/${slug}/`);
            const response = await fetch(`${API_BASE_URL}/api/posts/${slug}/`);
            if (!response.ok) {
                throw new Error('Error al cargar la entrada');
            }
            const data = await response.json();
            // console.log('Post data received:', data);
            setPost(data);
            setLoading(false);
        } catch (error) {
            // console.error('Error fetching post:', error);
            setLoading(false);
        }
    };

    const checkIfLiked = () => {
        const likedPosts = JSON.parse(localStorage.getItem('likedPosts') || '{}');
        if (likedPosts[slug]) {
            setHasLiked(true);
        }
    };

    const handleLike = async () => {
        try {
            const response = await fetch(`${API_BASE_URL}/api/posts/${slug}/like/`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
            });

            if (response.ok) {
                const data = await response.json();
                setPost(prevPost => ({ ...prevPost, likes: data.likes }));

                const likedPosts = JSON.parse(localStorage.getItem('likedPosts') || '{}');
                likedPosts[slug] = true;
                localStorage.setItem('likedPosts', JSON.stringify(likedPosts));

                setHasLiked(true);
                setLikeError('');
            } else if (response.status === 403) {
                const errorData = await response.json();
                setLikeError(errorData.error);

                const likedPosts = JSON.parse(localStorage.getItem('likedPosts') || '{}');
                likedPosts[slug] = true;
                localStorage.setItem('likedPosts', JSON.stringify(likedPosts));
                setHasLiked(true);
            } else {
                setLikeError('Error al dar like. Intenta nuevamente.');
            }
        } catch (error) {
            console.error('Error liking post:', error);
            setLikeError('Error de conexión. Intenta nuevamente.');
        }
    };

    if (loading) {
        return <div className="loading">Cargando entrada...</div>;
    }

    if (!post) {
        return <div className="error">Entrada no encontrada.</div>;
    }

    return (
        <div className="blog-post">
            <article>
                <h1>{post.title}</h1>
                <div className="post-meta">
                    <span className="post-date">
                        Publicado el {new Date(post.created_at).toLocaleDateString('es-ES', {
                            year: 'numeric',
                            month: 'long',
                            day: 'numeric'
                        })}
                    </span>
                </div>

                {/* AÑADIDO: ref para diagnosticar */}
                <div
                    ref={contentRef}
                    className="post-content"
                    dangerouslySetInnerHTML={{ __html: post.html_content }}
                />

                <div className="like-container">
                    <button
                        className={`like-button ${hasLiked ? 'liked' : ''}`}
                        onClick={handleLike}
                        disabled={hasLiked}
                    >
                        {hasLiked ? `✅ Me gusta (${post.likes})` : `👍 Me gusta (${post.likes})`}
                    </button>
                    {likeError && <div className="like-error">{likeError}</div>}
                </div>
            </article>
            <RecentPosts />
            <CommentSection postSlug={slug} />
        </div>
    );
};

export default BlogPost;